/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */


import {Component, OnInit} from '@angular/core';

import {Contract} from '../../shared/employees/employees.model';
import {ESSService} from '../employee-self.service';
import {ProfileMode} from '../../app.constants';

@Component({
  selector: 'ess-payslips',
  template: `
    <div *ngIf="contractId">
      <gp-pay-slip [contractId]="contractId" [profileMode]="profileMode"></gp-pay-slip>
    </div>`
})
export class PayslipsComponent implements OnInit {

  public static ACCESS_NAME: string = 'ESSPayslips';

  public contractId: number;
  public profileMode = ProfileMode.ESS;

  constructor(private essService: ESSService) {
  }

  public ngOnInit() {
    this.essService.currentContract.subscribe((c: Contract) => {
      this.contractId = c.id;
    });
  }
}
